<span class="placeholder" *ngIf="plano">
  <mat-icon
    class="icon-indicador-exclamation"
    svgIcon="exclamation-circle"
  ></mat-icon>
  <span>{{ diasRestantesAvaliacao }} dias restantes</span>
</span>
